module.exports = __webpack_public_path__ + "static/img/PS-NA3_80A.1232e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PS-NA3_80A.png
// module id = 6dJa
// module chunks = 1